import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { withPredicate } from 'routing';
import { Loader } from 'components';

function authenticationPredicate(stores, props) {
    return stores.authStore.isAuthenticated;
} 

function authenticationResolvingPredicate(stores, props) {
    return stores.authStore.loadingUser || false;
}

function authorizationPredicate(roles, stores, props) {
    const user = stores.authStore.user;
    if (user === undefined || user === null) {
        return false;
    }   
    
    const userRoles = user.roles;
    return checkRoles(roles, userRoles);
}

function shouldNavigateToMain(stores, props) {
    return !authenticationPredicate(stores, props);
} 

function checkRoles(roles, userRoles) {
    return (!roles || roles.length === 0) || roles.some(r => userRoles.some(ur => r === ur));
}

const UnauthorizedComponent = inject('authStore')(observer(({ authStore }) => {
    return (
        <div>
            <span>You are not authorized.</span>
            <a onClick={() => authStore.removeSession()}>Logout</a>
        </div>
    )
}));

const LoggedInWrap = withPredicate({
    predicate: (stores, props) => {
        return authenticationPredicate(stores, props)
    },
    resolvingPredicate: authenticationResolvingPredicate,
    redirectPath: '/login',
    ResolvingComponent: Loader
});


const AdminWrap = withPredicate({
    predicate: (stores, props) => {
        return authorizationPredicate(['Site Administrator', 'SiteUser'], stores, props);
    },
    FailureComponent: UnauthorizedComponent
});

const NavigateToMainWrap = withPredicate({
    predicate: shouldNavigateToMain,
    redirectPath: getPreviousPath
});


function getPreviousPath(location) {
    const { from } = location.state || { from: { pathname: '/' } };
    return from.pathname;
}

export {
    AdminWrap,
    NavigateToMainWrap,
    LoggedInWrap,   
}





// WEBPACK FOOTER //
// ./src/routing/auth.js